import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'PlantLayoutAreaDrawings',
  //   description: 'description of PlantLayoutAreaDrawings',
  //   url: '/plant-layout-area-drawings',
  // },
];

export default help;
